export default "__VITE_ASSET__804af855__"